<template>
    <div class="row">
        <div class="col-sm-4 field-label">{{ label }}</div>
        <div class="col-sm-8 field-value">{{ displayValue }}</div>
    </div>
</template>

<script>
    import formElementMixin from '@/components/mixins/FormElementMixin'

    export default {
        mixins: [formElementMixin]
    }
</script>


// WEBPACK FOOTER //
// src/components/form_elements/Detail.vue